import React from "react";

export const LazySlackConnectedSurveillanceAppPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SlackConnectedSurveillanceApp" */ "./SlackConnectedSurveillanceApp"
        )
);
